import { get } from '../index';

// TikTok requires creator_info to be fetched WHEN THE POST PAGE RENDERS — the
// nickname shown, the privacy options offered, the interaction toggles greyed
// and the can-post check all come from this one live call. Deliberately not
// cached: the caps change per creator per day, and a stale nickname would name
// the wrong account, which is the very thing rule 1a exists to prevent.
export const fetchTikTokCreatorInfo = async (brandId) => {
  const res = await get(`/social/tiktok/creator-info/${brandId}`);
  const d = (res && res.data) || res;
  if (!d || d.error) throw new Error((d && d.error) || 'Could not reach TikTok');
  const info = d.data || d;
  // canPost is decided SERVER-side and always present. It is not a field
  // TikTok returns — verified live 2026-08-09, the data block carries only
  // creator_*/privacy_level_options/*_disabled/max_video_post_duration_sec.
  // The signal is the response's ERROR ENVELOPE, at HTTP 200, so only the
  // proxy can see it. Defaulting to true here would have re-hidden exactly
  // what rule 1b requires us to surface.
  return info;
};
